import { render, staticRenderFns } from "./business_form_1009.vue?vue&type=template&id=e71ad48a&scoped=true&"
import script from "./business_form_1009.vue?vue&type=script&lang=js&"
export * from "./business_form_1009.vue?vue&type=script&lang=js&"
import style0 from "./business_form_1009.vue?vue&type=style&index=0&id=e71ad48a&prod&lang=css&"
import style1 from "../business_form/business_form.css?vue&type=style&index=1&id=e71ad48a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71ad48a",
  null
  
)

export default component.exports